import flightEpic from "./FlightDetailsEpic.js";
import { combineEpics } from "redux-observable";
import FlightTrafficEpics from "../components/FlightTraffic/FlightTraffic.epics.js";
import FlightEditEpics from "../components/FlightEdit/FlightEdit.epics.js";
import FlightCompositionEpics from "../components/Composition/Composition.epics.js";
const rootEpic = combineEpics(flightEpic, FlightTrafficEpics, FlightEditEpics, FlightCompositionEpics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
